import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { TokenStorageService } from '../../_services/token-storage.service';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { RefreshTTokenRequest } from 'src/app/_models/Authentication/refresh-token-request';
import { JwtHelperService } from '@auth0/angular-jwt';
import { RoleTypeEnum } from 'src/app/admin-panel/enums/role-type.enum';
import { RoleNameEnum } from 'src/app/admin-panel/enums/role-name.enum';
import { SocialAuthenticateRequestModel } from 'src/app/_models/Authentication/social-authenticate-request';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  submitted = false;
  loadingPage = false;
  isLoggedIn = false;
  errorMessage = '';
  refresTokenRequest: RefreshTTokenRequest = new RefreshTTokenRequest();
  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private _jwtHelperService: JwtHelperService,
    public messageService: MessageService,
  ) { }

  ngOnInit(): void {
    this.initLoginForm();
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      // this.roles = this.tokenStorage.getUser().roles;
    }
  }

  private initLoginForm(): void {
    this.loginForm = new UntypedFormGroup({
      username: new UntypedFormControl('', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      password: new UntypedFormControl('',
        [
          Validators.required,
          // Validators.minLength(6),
          // Validators.pattern('^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\\D*\\d)[A-Za-z\\d!$%@#+£€*?_|&.,\^\=\"\'\;\:-]{8,}$')
        ]
      ),
      rememberme: new UntypedFormControl(false),
      selectedLanguage: new UntypedFormControl()
    });
    if (window.localStorage.getItem('rememberme') != undefined && window.localStorage.getItem('rememberme') != null) {
      this.rememberme?.setValue(window.localStorage.getItem('rememberme'))
      this.username?.setValue(window.localStorage.getItem('username'))
      this.password?.setValue(window.localStorage.getItem('username'))
      this.loginForm.get('password')?.clearValidators();
    }

  }

  onLoginFormSubmit(): void {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    this.loadingPage = true;
    let data = this.loginForm.value;
    if (window.localStorage.getItem('rememberme') != null && window.localStorage.getItem('rememberme') && this.rememberme?.value) {
      const refreshToken = this.tokenStorage.getRefreshToken();
      if (refreshToken != null) {
        this.refresTokenRequest.token = refreshToken;
        this.apiService.refreshToken(this.refresTokenRequest).subscribe((response) => {
          if (response) {
            this.loadingPage = false;
            this.authService._isLoggedIn$.next(true);
            this.tokenStorage.saveToken(response.jwtToken);
            this.tokenStorage.saveRefreshToken(response.refreshToken);
            this.authService.handleAuthentication();
            this.router.navigate(['/promoter/venues']);
          }
        });
      }
    }
    else {
      if (!this.rememberme?.value) {
        window.localStorage.removeItem('rememberme');
        window.localStorage.removeItem('username');
        this.tokenStorage.removeRefreshToken();

      }
      this.apiService.authenticate(data).subscribe((response) => {
        if (response) {
          this.loadingPage = false;
          this.authService._isLoggedIn$.next(true);
          this.tokenStorage.saveToken(response.jwtToken);
          this.tokenStorage.saveRefreshToken(response.refreshToken);
          if (this.rememberme?.value) {
            window.localStorage.setItem('rememberme', this.rememberme?.value);
            window.localStorage.setItem('username', this.username?.value);
            this.tokenStorage.saveRefreshToken(response.refreshToken);
          }
          var token = this._jwtHelperService.decodeToken(response.jwtToken);
          const ustp = token.ustp.split(',').map((x: string) => +x);
          const rlnm = token.rlnm.split(',').map((x: string) => +x);

          if (ustp.includes(RoleTypeEnum.Admin)) {
            this.authService._isSuperAdmin$.next(true);
            this.authService._isAdvertiser$.next(false);
            if (rlnm.includes(RoleNameEnum.Techsupport)) {
              this.authService._isTechSupport$.next(true);
            } else {
              this.authService._isTechSupport$.next(false);
            }
            this.authService.handleAdminAuthentication();
            this.router.navigate(['/admin/my-profile']);
          } else if (ustp.includes(RoleTypeEnum.Advertiser)) {
            this.authService._isSuperAdmin$.next(false);
            this.authService._isTechSupport$.next(false);
            this.authService._isAdvertiser$.next(true);
            this.authService.handleAuthentication();
            this.router.navigate(['/promoter/venues']);
          } else {
            this.messageService.add({ severity: 'warn', summary: "User is registered to another product from Socialite", life: 4000 });
          }
        }
      }, (error) => {
        this.loadingPage = false;
      });
    }

  }

  signInWithFacebook() {
    this.authService.facebookAuth().then((result) => {
      this.loadingPage = true;
      const socialCredentials = new SocialAuthenticateRequestModel();
      //@ts-ignore
      socialCredentials.token = result.user._delegate.accessToken;
      this.apiService.authenticateSocialLogin(socialCredentials).subscribe(response => {
        if (response) {
          this.loadingPage = false;
          var token = this._jwtHelperService.decodeToken(response.jwtToken);
          if (token.ustp == RoleTypeEnum.Advertiser) {
            this.authService._isLoggedIn$.next(true);
            this.tokenStorage.saveToken(response.jwtToken);
            this.tokenStorage.saveRefreshToken(response.refreshToken);
            this.authService._isSuperAdmin$.next(false);
            this.authService._isTechSupport$.next(false);
            this.authService._isAdvertiser$.next(true);
            this.authService.handleAuthentication();
            this.router.navigate(['/promoter/venues']);
          } else {
            this.messageService.add({ severity: 'warn', summary: "User is registered to another product from Socialite", life: 4000 });
          }
        }
      }, (error: HttpErrorResponse) => {//do whatever with the error
        this.loadingPage = false;
        if (error.message == "User does not exist!") {
          this.router.navigate(['./sign-up']);
        }
      })
    }, (error: HttpErrorResponse) => {
      this.loadingPage = false;
      if (!error.message.includes('popup has been closed by the user')) {
        this.messageService.add({ severity: 'warn', summary: error.message, life: 4000 });
      }
    });
  }

  onChangeRememberMe(value: boolean) {
    if (value) {
      if (this.tokenStorage.getRefreshToken() != null) {
        this.username?.setValue(window.localStorage.getItem('username'))
        this.password?.setValue(window.localStorage.getItem('username'))
      }
      this.loginForm.get('password')?.clearValidators();
    }
    else {
      this.password?.setValue("");
      this.loginForm.reset();
      this.loginForm.get('password')?.addValidators([
        Validators.required,
        // Validators.minLength(6),
        // Validators.pattern('^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\\D*\\d)[A-Za-z\\d!$%@#£€*?&.,]{8,}$')
      ]);
    }
  }

  get username() { return this.loginForm.get('username'); }
  get password() { return this.loginForm.get('password'); }
  get rememberme() { return this.loginForm.get('rememberme') }
}
